import Banner from '../components/Banner';
import Footer from '../components/Footer';
import PoliticasPrd from '../components/Politicas';
import React from 'react';


const PoliticasPage: React.FC = () => {
  return (
    <div className="page-container">
      <Banner />
      <main className="login-main">
           <PoliticasPrd />
      </main>
      <Footer />
    </div>
  );
};

export default PoliticasPage;